import styled from 'styled-components';
import { Container } from 'reactstrap';
import { themeColor } from '@whitelabel/helpers/style/colors';

export const StyledSecondaryNavBar = styled.nav`
  padding-block: 1rem;
  background-color: ${themeColor('tertiaryBg')};
`;

export const StyledContainer = styled(Container)`
  display: flex;
  align-content: center;
  flex-wrap: wrap;
  height: 100%;
  column-gap: 2rem;
`;
